import { Suspense, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { Footer } from '@/components/layout/Footer'
import { Nav } from '@/components/layout/Nav'
import { PATHS } from './routes'
import {
  About,
  Blog,
  BlogPost,
  Careers,
  Home,
  HumanAIProject,
  Paul,
  NotFound,
  Privacy,
  Terms,
} from './lazyPages'

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  // The prerendered-boot flag only applies to the FIRST route; later
  // navigations get the normal loading fallback again.
  useEffect(() => () => {
    ;(window as unknown as { __PRERENDERED?: boolean }).__PRERENDERED = false
  }, [pathname])

  return null
}

function LoadingFallback() {
  // When the shell arrived prerendered, never flash a spinner over real content.
  if ((window as unknown as { __PRERENDERED?: boolean }).__PRERENDERED) return null
  return (
    <div className="route-loader" role="status" aria-label="Loading page">
      <div className="route-loader-spinner spin" />
    </div>
  )
}

export function AppRouter() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <ScrollToTop />
      <Nav />
      <main className="app-main">
        <Routes>
          <Route path={PATHS.home} element={<Home />} />
          <Route path={PATHS.about} element={<About />} />
          <Route path={PATHS.paul} element={<Paul />} />
          <Route path={PATHS.blog} element={<Blog />} />
          <Route path={PATHS.blogPost} element={<BlogPost />} />
          <Route path={PATHS.humanAiProject} element={<HumanAIProject />} />
          <Route path={PATHS.research} element={<HumanAIProject />} />
          <Route path={PATHS.terms} element={<Terms />} />
          <Route path={PATHS.privacy} element={<Privacy />} />
          <Route path={PATHS.careers} element={<Careers />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </Suspense>
  )
}
